import { Falcon } from 'modules/macro';
import { Box } from 'modules/v2/foundation/Box';
import { Typography } from 'modules/v2/foundation/Typography';
import { AccordionContent, AccordionContentSpacer, AccordionHeader, AccordionItemContainer, AccordionStateIconWrapper, AccordionTrigger, } from './styled';
export function AccordionItem(props) {
    const { value, title, subtitle, children, endElement } = props;
    const handleEndElementClick = (event) => {
        event.stopPropagation();
    };
    return (<AccordionItemContainer value={value}>
      <AccordionHeader render={<AccordionTrigger>
            <AccordionStateIconWrapper>
              <Falcon icon="caret-right" $size={10} $color="gray.600" sourceConfig={{ style: 'solid', family: 'classic' }}/>
            </AccordionStateIconWrapper>

            <Box flexDirection="column" alignItems="flex-start">
              <Typography $appearance="300" $fontSize="small" $fontWeight="medium" $lineHeight="neutralized">
                {title}
              </Typography>
              {subtitle && (<Typography $appearance="100" $fontSize="tiny" $lineHeight="neutralized">
                  {subtitle}
                </Typography>)}
            </Box>

            {endElement && (<Box ml="auto" onClick={handleEndElementClick}>
                {endElement}
              </Box>)}
          </AccordionTrigger>}/>
      <AccordionContent>
        <AccordionContentSpacer>{children}</AccordionContentSpacer>
      </AccordionContent>
    </AccordionItemContainer>);
}
